import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

import { ref } from "vue";
import dayjs from "dayjs";
import { getListData } from "@/service/main/system";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  emits: ['search'],
  setup(__props, { emit: __emit }) {

const date = ref<string>(dayjs().format("YYYY-MM-DD"));
const employee = ref<string>('');
const employeeList = ref<any>([]);
const departmentList = ref<any>([]);
const store = useStore()
const userInfo = store.state.login.userInfo
const group = ref<string>();
const canSelectGroup = ref<boolean>(true);
const canSelectUser = ref<boolean>(true);

if(userInfo.isManager) {
  group.value = userInfo.deptId
  canSelectGroup.value = false
  canSelectUser.value = false
} else {
  group.value = userInfo.deptId
  employee.value = userInfo.id
  canSelectGroup.value = true
  canSelectUser.value = false
}

const $emit = __emit;

const emitSearch = () => {
  const params = {
    date: date.value || undefined,
    employee: employee.value || undefined,
    group: group.value || undefined
  };
  $emit('search', params);
};

emitSearch()

const handleResetClick = () => {
  date.value = dayjs().format("YYYY-MM-DD");
  if(userInfo.isManager) {
    group.value = userInfo.deptId
  } else {
    employee.value = userInfo.id
  }
  emitSearch();
};

const getEmp = async () => {
  employeeList.value = await getListData('/main/employee/queryAllEmpList', {})
}
getEmp();


const getDepartment = async () => {
  departmentList.value = store.state.login.depts
}
getDepartment();


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    inline: true,
    onSubmit: _withModifiers(emitSearch, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { label: "选择日期" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
            clearable: false,
            type: "date",
            placeholder: "选择日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "部门" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: group.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((group).value = $event)),
            clearable: "",
            filterable: "",
            disabled: canSelectGroup.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departmentList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "员工" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: employee.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((employee).value = $event)),
            clearable: "",
            filterable: "",
            disabled: canSelectUser.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.realName,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: "el-icon-refresh",
            onClick: handleResetClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-search",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})